import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import {getFieldsExport} from 'utils/utils'
import {icons} from 'utils/enums/icons'

const Controls = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`

const Control = styled.div`
    display: flex;
    align-items: center;
    font-weight: 600;

    i {
        font-size: 25px;
        color: #a0b7be;
        margin-right: 10px;
    }
`

class ExcelExport extends React.PureComponent {
    constructor(props) {
        super(props)

        this.fields = getFieldsExport(props.entity)
        const fields = props.template ? props.template.fields.map(item => item.pathId.join(',')) :
            this.fields.map(item => item.fields.map(field => field.id)).flat()

        this.state = {
            name: props.template ? props.template.name : props.name,
            fields: fields
        }

    }

    handleSelect = (e) => {
        const fields = [...this.state.fields]
        const index = fields.findIndex(item => item === e.currentTarget.value)
        index === -1 ? fields.splice(fields.length, 0, e.currentTarget.value) :
            fields.splice(index, 1)

        this.setState({ fields })
    }

    exportExcel = () => {
        const fields = this.fields.map(obj => obj.fields).flat()
        const filterFields = this.state.fields.filter(item => fields.find(field => field.id === item))

        this.props.exportExcel({
            id: this.props.template ? this.props.template.id : undefined,
            entityId: this.props.entity,
            name: this.state.name,
            fields: filterFields.map(item => {
                return {
                    pathId: fields.find(field => field.id === item).pathId
                }
            })
        })
    }

    deleteExcelTemplate = () => {
        this.props.deleteExcelTemplate(this.props.template.id)
        this.props.handleClose()
    }

    render() {
        const { intl } = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "sidebar.excel"})}
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        style={{width: '100%'}}
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        label={intl.formatMessage({id: "sidebar.template_name"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH
                        }}
                    />
                    {this.fields.map(item =>
                        <Controls key={item.id}>
                            {item.fields.map(field =>
                                <Control key={field.id}>
                                    <Checkbox
                                        value={field.id}
                                        checked={!!this.state.fields.find(obj => obj === field.id)}
                                        onChange={this.handleSelect}
                                    />
                                    <i className={icons[field.type]} />
                                    {field.name}
                                </Control>
                            )}
                        </Controls>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.template &&
                        <Button variant="contained"
                            onClick={this.deleteExcelTemplate}
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button variant="contained"
                        disabled={this.state.name.replace(/\s/g, '') === ''}
                        onClick={this.exportExcel}
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_save_export"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExcelExport)
